import React, { useEffect, useState } from "react";
import "./Setting.css";
import axios from "axios";
import { config } from "../../../confi";
import Spinner from "../../Loader/Spinner";
import { hasFormSubmit } from "@testing-library/user-event/dist/utils";
import { color } from "framer-motion";

function Setting() {
  const [img, setimg] = useState("1");
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();

    if (img === "1") {
      return;
    }

    const formData = new FormData();

    formData.append("photo", img);

    try {
      setLoading(true);
      setmsg(false);

      const response = await axios.post(
        `${config.apiBaseURL}/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log(response);
      // const res_data = await response.json();
      console.log(response.data);
      if (response.status === 200 && response.data.status === "0") {
        setmsg("Background Image change Successully");
        setimg("1");
      } else {
      }
    } catch (error) {
      setimg("1");
      setmsg("Ops Something wrong");
    }
    setimg("1");
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <span>
          <Spinner />{" "}
        </span>
      ) : (
        <div className="pppp">
          <h3 style={{ textAlign: "center", fontStyle: "italic" }}>
            Set Background Image
          </h3>
          <div className="full-setting">
            <div className="full-setting-option">
              <h3>Select Image</h3> <br></br>
              <span style={{ fontWeight: "bold" }}>
                Image width must be (1500px X 600px)
              </span>
              <input
                type="file"
                onChange={(e) => {
                  setimg(e.target.files[0]);
                }}
              ></input>
              <br></br>
              <button onClick={submitHandler}>submit</button>
            </div>
          </div>
        </div>
      )}
      {msg && <p style={{ textAlign: "center", color: "green" }}>{msg}</p>}
    </>
  );
}

export default Setting;
